var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowUpYellow(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 6,
    viewBox: "0 0 12 6",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00003 -3.09944e-05C5.87216 -3.09944e-05 5.74416 0.0488439 5.64653 0.146469L0.646531 5.14647C0.451156 5.34184 0.451156 5.65822 0.646531 5.85347C0.841906 6.04872 1.15828 6.04884 1.35353 5.85347L6.00003 1.20697L10.6465 5.85347C10.8419 6.04884 11.1583 6.04884 11.3535 5.85347C11.5488 5.65809 11.5489 5.34172 11.3535 5.14647L6.35353 0.146469C6.25591 0.0488439 6.12791 -3.09944e-05 6.00003 -3.09944e-05Z",
    fill: "#F8D210"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowUpYellow);
export default __webpack_public_path__ + "static/media/arrow-up-yellow.84da89e0d06dcae93adad8d3dbb7f0db.svg";
export { ForwardRef as ReactComponent };